document.addEventListener('click', function (e) {
  const option = e.target.closest('.weight-option');
  if (!option) return;

  e.preventDefault();

  const card = option.closest('.product-thumbnail');
  if (!card) return;

  // Active state
  card.querySelectorAll('.weight-option').forEach(el => {
    el.classList.remove('active');
  });
  option.classList.add('active');

  // Update title
  const title = card.querySelector('.js-product-title');
  if (title) {
    title.textContent = option.dataset.title;
    title.href = option.dataset.url;
  }

  // Update image link
  const imageLink = card.querySelector('.product-thumbnail__link');
  if (imageLink) {
    imageLink.href = option.dataset.url;
  }

  // Update price
  const price = card.querySelector('.js-product-price .money');
  if (price) {
    price.textContent = option.dataset.price;
  }

 const unitPrice = card.querySelector('.js-unit-price');

  if (unitPrice) {
    if (option.dataset.unitPrice) {
      unitPrice.innerHTML = option.dataset.unitPrice;
      unitPrice.style.display = '';
    } else {
      unitPrice.style.display = 'none';
    }
  }

  // Update images
  const images = card.querySelectorAll('img');

  // Primary image
  if (images[0]) {
    images[0].src = option.dataset.image;
    images[0].srcset = option.dataset.image;

    images[0].dataset.rimgTemplate = option.dataset.image;
    images[0].dataset.rimg = 'loaded';

    images[0].dispatchEvent(new CustomEvent('rimg:load'));
  }

  // Secondary (hover) image
  if (images[1] && option.dataset.secondaryImage) {
    images[1].src = option.dataset.secondaryImage;
    images[1].srcset = option.dataset.secondaryImage;

    images[1].dataset.rimgTemplate = option.dataset.secondaryImage;
    images[1].dataset.rimg = 'loaded';

    images[1].dispatchEvent(new CustomEvent('rimg:load'));
  }

  // Update Quick Shop button
  const quickShop = card.querySelector('[data-quickshop-button]');
  if (quickShop) {
    quickShop.dataset.quickshopUrl = option.dataset.url;
  }
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.cart-q');

  if (btn) {
    e.stopPropagation();

    document.querySelectorAll('.cart-tip.show').forEach((tip) => {
      if (tip !== btn.nextElementSibling) {
        tip.classList.remove('show');
      }
    });

    btn.nextElementSibling?.classList.toggle('show');
    return;
  }

  document.querySelectorAll('.cart-tip.show').forEach((tip) => {
    tip.classList.remove('show');
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.querySelector('[data-cart-overlay]');
  if (!overlay) return;

  const updateScrollLock = () => {
    document.documentElement.classList.toggle(
      'scroll-locked',
      overlay.classList.contains('active')
    );
  };

  updateScrollLock();

  new MutationObserver(updateScrollLock).observe(overlay, {
    attributes: true,
    attributeFilter: ['class']
  });
});